// src/utils/breadcrumbs.js
export const generateBreadcrumbs = ({ pageType, data = {} }) => {
  const items = [{ label: "Home", url: "/" }];

  switch (pageType) {
    case "blog":
      items.push({ label: "Blog", url: "/blog" });
      if (data?.title) items.push({ label: data.title });
      break;

    case "products":
      items.push({ label: "Products", url: "/products" });
      if (data?.category)
        items.push({ label: data.category.name, url: data.category.url });
      if (data?.product) items.push({ label: data.product.name });
      break;

    case "productDetails":
      items.push({ label: "Products", url: "/products" });
      items.push({ label: "Product Details", url: null }); // static step, not clickable
      if (data?.product)
        items.push({
          label: data.product.name,
          url: `/product/${data.product.id}`,
        });
      break;

    case "aboutus":
      items.push({ label: "About Us", url: "/about-us" });
      break;

    case "contactus":
      items.push({ label: "Contact Us", url: "/contact-us" });
      break;

    case "market":
      items.push({ label: "Market", url: "/market" });
      break;

    case "buy":
      items.push({ label: "Buy Scrap", url: "/buy" });
      break;

    case "sell":
      items.push({ label: "Sell Scrap", url: "/sell" });
      break;

    case "howItWorks":
      items.push({ label: "How It Works", url: "/how-it-works" });
      break;

    default:
      break;
  }

  return items;
};
